import styled from 'styled-components';
import { HeadingExtraBoldS } from '../../../styles/globals';
import { ITheme } from '../../../styles/theme';
import CloseMark from '@/assets/icons/closeMark.svg?react';

interface IHeaderElem {
  theme: ITheme;
  hasBorder: boolean;
  hasCloseOnly: boolean;
}

export const HeaderElem = styled.header<IHeaderElem>`
  ${({ theme, hasBorder, hasCloseOnly }: IHeaderElem) => `
    display: flex;
    height: 72px;
    padding: ${theme.layout.spacing.mili} ${theme.layout.spacing.decy};
    align-items: center;
    justify-content: ${hasCloseOnly ? 'flex-end' : 'space-between'};
    border-bottom: ${hasBorder ? `1px solid ${theme.colors.neutral.primary[30]}` : 'none'};
  `};
`;

export const Title = styled(HeadingExtraBoldS)``;

export const CloseButton = styled.button`
  display: flex;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const CloseIcon = styled(CloseMark)`
  width: 100%;
  height: 100%;
`;
